import { MapGroupId } from "../../types";
import img from "../../mapImages/ShorelineResort.webp";

const mapData = {
  groupId: MapGroupId.Shoreline,
  groupName: {
    en: "Shoreline",
    ru: "Берег",
  },
  title: {
    en: "Resort",
    ru: "Санаторий",
  },
  imgPath: img,
  extracts: [],
};

export default mapData;
